
import { defineComponent, ref, onMounted, computed, getCurrentInstance } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import FilterBar from "@/components/dropdown/FilterBar.vue";
import ModalDeleteAndReason from "@/components/modals/wizards/ModalDeleteAndReason.vue";
import CandidateQuickDrawer from "@/components/customers/CandidateQuickDrawer.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"
import { titleCaseName } from "@/core/helpers/format";
import moment from "moment"
import Permission from "@/core/config/Permission";
import { debounce } from "debounce";
import Dropzone from "dropzone";
import { hideModal } from "@/core/helpers/dom";
import * as XLSX from "xlsx-js-style"; //đọc file .xls Điểm TN/Học bạ tải từ hệ thống Bộ GD&ĐT
import { exportStyledXlsx, XlsxColumn } from "@/core/helpers/exportXlsx"; //file Excel rà soát trường/ưu tiên sau import điểm
import { gradWarningsOf } from "@/core/helpers/gradCheck"; //row vàng cảnh báo tốt nghiệp (1 nguồn logic với trang chi tiết/drawer)

interface ICustomer {
  id: string;
  fullName: string;
  phoneNumber: string;
  school: string;
  idCard: string;
  date: string;
  checkbox: boolean;
  opportunityid?: any
  leadid?: any
}
interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}
export default defineComponent({
  name: "customers-listing",
  components: {
    Datatable,
    FilterBar,
    ModalDeleteAndReason,
    CandidateQuickDrawer,
  },
  data() {
    return {
      filter: {} as any,
      loading: false,
      urlImport: '',
      //link file mẫu import theo môi trường (trước hardcode api.dev...) — file tĩnh ở ROOT host API
      sampleImportUrl: (process.env.VUE_APP_API_URL || '').replace(/\/api\/?$/, '') + '/sample_danhsachungvien_bgddt.csv',
      //Import điểm từ file .xls của Bộ (Điểm TN / Học bạ): kết quả parse chờ xác nhận import
      //Nhập file nhập liệu ứng viên: aoa đọc client-side chờ gửi
      dataEntryImport: null as any,
      dataEntryImportLoading: false,
      dataEntrySubmitting: false,
      //Xuất file nhập liệu: điều kiện lọc + số dòng/file (mặc định năm nay + tình trạng Chứng nhận TNTT)
      dataEntryExport: { assignee: '', class12ProvinceId: '', class12SchoolId: '', graduatedYear: String(new Date().getFullYear()), highschoolGraduation: 'temp_graduated', rowsPerFile: 200 } as any,
      deProvinces: [] as any[],
      deSchools: [] as any[],
      deYears: [] as string[],
      deUseSelection: false,
      deIsAdmin: false,
      deExporting: false,
      deStep: 'filter' as 'filter' | 'preview',   //modal 2 bước: lọc -> xem trước
      dePreview: null as any,                       //{ total, files, rpf, cols, sample, ex }
      arrUsers: [] as any,
      arrGroups: [] as any,
      badMajorCount: 0,
      dupIdCardCount: 0,
    }
  },
  watch: {
    search: debounce(async function (this) {
      this.pagination.currentPage = 1
      try { localStorage.setItem('tsSearch:' + (window.location.pathname || ''), this.search || '') } catch (e) { /* ignore */ }
      this.getData(this.filter)
      // this.searchItems()
    }, 300)
  },
  methods: {
    // Bấm TÊN ứng viên -> mở drawer xem nhanh (cá nhân + học tập); bấm cột khác vẫn đi trang chi tiết
    openQuickView(customer) {
      (this.$refs.candidateQuickDrawer as any)?.open(customer.id);
    },
    async callSyncCRM(dataCustomer) {
      
      let urlApi = `/admission/student/crm/sync`
      let method = 'post'
      let tempData = {
        student: dataCustomer,
        // scholarshipregister: scholarshipregister
      } as any
      Swal.fire({
        title: 'Bạn có muốn đồng bộ sinh viên này không ?',
        // text: "Bạn sẽ không thể hoàn nguyên điều này!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Đồng bộ',
        cancelButtonText: 'Hủy'
      }).then(async (result) => {
        if (result.isConfirmed) {
          // this.popupLoading()
          await axios[method](`${urlApi}`, tempData)
          .then(( {data} ) => {
            if(data.errors && data.errors.length != 0) {
              Swal.fire({
                  text: data.errors.join(','),
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Đóng",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  // location.reload()
              }); 
            }
            else {
              dataCustomer.issynccrm = true
              Swal.fire({
                  text: "Đồng bộ thành công",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Trở lại",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  // location.reload()
                  let index = this.tableData.findIndex(i=> i.id == dataCustomer.id)
                  if(index > -1) {
                    this.tableData[index].opportunityid = data.student?.opportunityid
                    this.tableData[index].leadid = data.student?.leadid
                  }

                  // hideModal(addCustomerModalRef.value);
              });  
            }
                        
          })
          .catch((response) => {
              Swal.fire({
                  text: response.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              });  
            });
        }
      })
          },
    getInforName(arr,id,field,) {
      let temp = arr.find((i: any) => i.id == id)||{} as any
      return temp[field]
    },
    //rule theo NHÁNH đang chọn (đủ mọi nhánh — bug cũ: mở modal Export "Tất cả" vẫn gắn rule assignee)
    handleChangeTypeOption() {
      if(this.formData.typeOption == 1) {
        this.rules = {
          assignee: [
            {
              required: true,
              message: "Vui lòng chọn người phụ trách",
              trigger: "change",
            },
          ],
        }
      }
      else if (this.formData.typeOption == 2) {
        this.rules = {
          groupAssignee: [
            {
              required: true,
              message: "Vui lòng chọn nhóm phụ trách",
              trigger: "change",
            },
          ],
        }
      }
      else {
        this.rules = {}
      }
      //đổi nhánh -> xoá lỗi validate của nhánh cũ còn treo
      this.assignFormRef?.clearValidate?.()
      this.exportFormRef?.clearValidate?.()
    },
    handleClickModalAssign(typeDefault?: any) {
      this.formData = {
        typeOption: typeDefault != undefined ? typeDefault:1,
        assignee: '',
        groupAssignee: ''
      }
      // Modal GÁN (typeDefault undefined; có typeDefault là modal Export dùng chung handler):
      // soi phụ trách hiện tại của các ứng viên đã chọn -> báo ghi đè; tất cả cùng 1 người -> prefill người đó
      this.assignCurrent = { assigned: 0, namesText: '' }
      if (typeDefault == undefined) {
        const rows = (this.tableData || []).filter((it: any) => (this.checkedCustomers as any[]).includes(it.id))
        const assignedIds = rows.map((it: any) => it.assignee).filter((v: any) => v)
        const uniq = Array.from(new Set(assignedIds))
        const names = uniq.map((id: any) => this.getInforName(this.arrUsers, id, 'fullName')).filter(Boolean)
        this.assignCurrent = {
          assigned: assignedIds.length,
          namesText: names.slice(0, 2).join(', ') + (names.length > 2 ? ` +${names.length - 2} người khác` : ''),
        }
        if (rows.length > 0 && assignedIds.length === rows.length && uniq.length === 1) {
          this.formData.assignee = uniq[0]
        }
      }
      this.handleChangeTypeOption()
    },
    getArrUsers() {
      axios.get(`/user/findusersforselect`)
        .then(({ data }) => {
          this.arrUsers = data
        })
        .catch(({ response }) => {
        });
    },
    getArrGroups() {
      axios.get(`/groups/`)
      .then(({ data }) => {
        this.arrGroups = data
      })
      .catch(({ response }) => {
      });
    },
    importFile() {
        setTimeout(()=>{
            this.initDropzone()
        },100)
    },
    getCookie(name: string): string|null {
      const nameLenPlus = (name.length + 1);
      return document.cookie
          .split(';')
          .map(c => c.trim())
          .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
          })
          .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
          })[0] || null;
    },
    //====== Import điểm từ file .xls của Bộ GD&ĐT (parse tại trình duyệt bằng xlsx-js-style) ======
    //Tự nhận diện loại file theo header thật (đã đối chiếu file tập huấn 7.2026):
    //- Điểm TN THPT: header dòng 1, có cột SBD + ĐDCN, mã môn ngắn TO/VA/LI/HO/SI/SU/DI/KTPL/TI + NN (Mã môn NN)
    //- Học bạ: header dòng 3, có cột "Số ĐDCN" + "Lớp" (mỗi thí sinh 3 dòng lớp 10/11/12), điểm lấy cột "<Môn> CN"
    //===== FILE NHẬP LIỆU ỨNG VIÊN (xuất tất cả cột -> TTV sửa -> nhập lại có verify + timeline) =====
    //Mở modal xuất: nạp danh mục Tỉnh + năm TN; nếu đang chọn record thì xuất đúng các record đó
    async openDataEntryExport() {
      this.deStep = 'filter'
      this.dePreview = null
      this.deIsAdmin = this.userLocal?.role == 1 || this.userLocal?.role == 3
      this.deUseSelection = !!(this.checkedCustomers && this.checkedCustomers.length)
      this.dataEntryExport = { assignee: '', class12ProvinceId: '', class12SchoolId: '', graduatedYear: String(new Date().getFullYear()), highschoolGraduation: 'temp_graduated', rowsPerFile: this.dataEntryExport.rowsPerFile || 200 }
      this.deSchools = []
      if (!this.deYears.length) { const y = new Date().getFullYear(); this.deYears = Array.from({ length: 16 }, (_, i) => String(y - i)) }
      if (!this.deProvinces.length) {
        try {
          const { data } = await axios.get('/province/')
          this.deProvinces = (data || []).map((i: any) => ({ label: i.name, value: i.id, code: i.code }))
        } catch (e) { /* để trống -> "Tất cả" */ }
      }
    },
    async deGetSchool(provinceId: any) {
      this.dataEntryExport.class12SchoolId = ''
      this.deSchools = []
      if (!provinceId) return
      const prov = this.deProvinces.find((p: any) => p.value === provinceId)
      const params = prov?.code ? `?pvcode=${prov.code}` : ''
      try {
        const { data } = await axios.get(`/school/${params}`)
        this.deSchools = (data || []).map((i: any) => ({ label: i.name, value: i.id }))
      } catch (e) { /* ignore */ }
    },
    //BƯỚC 1 -> 2: tải dữ liệu theo bộ lọc rồi hiện XEM TRƯỚC (chưa tải file)
    async fetchDataEntryPreview() {
      let payload: any
      if (this.deUseSelection) {
        payload = { ids: this.checkedCustomers }
      } else {
        if (this.deIsAdmin && !this.dataEntryExport.assignee) {
          Swal.fire({ text: 'Vui lòng chọn Người phụ trách trước khi xem trước.', icon: 'warning', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
        const filter: any = {}
        if (this.dataEntryExport.assignee) filter.assignee = this.dataEntryExport.assignee
        if (this.dataEntryExport.class12ProvinceId) filter.class12ProvinceId = this.dataEntryExport.class12ProvinceId
        if (this.dataEntryExport.class12SchoolId) filter.class12SchoolId = this.dataEntryExport.class12SchoolId
        if (this.dataEntryExport.graduatedYear) filter.graduatedYear = this.dataEntryExport.graduatedYear
        if (this.dataEntryExport.highschoolGraduation) filter.highschoolGraduation = this.dataEntryExport.highschoolGraduation
        payload = { filter }
      }
      const rpf = Math.min(500, Math.max(50, Number(this.dataEntryExport.rowsPerFile) || 200))
      this.deExporting = true
      await axios.post('/admission/student/dataentry/export', payload)
        .then(({ data: ex }) => {
          //cột "Họ và tên" (nhãn 2 dòng -> so dòng đầu) để lấy ví dụ tên
          const nameIdx = (ex.columns || []).findIndex((c: any) => String(c.label || '').split('\n')[0].trim() === 'Họ và tên')
          const sample = nameIdx >= 0 ? (ex.rows || []).slice(0, 15).map((r: any) => r[nameIdx]).filter(Boolean) : []
          this.dePreview = {
            total: ex.total,
            rpf,
            files: Math.ceil((ex.total || 0) / rpf),
            cols: (ex.columns || []).length,
            sample,
            ex, //giữ để tải file ở bước xác nhận, không phải gọi lại
          }
          this.deStep = 'preview'
        }).catch(({ response }) => {
          Swal.fire({ text: response?.data?.errorMessage || response?.data?.message || 'Tải dữ liệu xem trước thất bại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        })
      this.deExporting = false
    },
    //BƯỚC 2: đồng ý -> tách + tải file từ dữ liệu đã xem trước (không gọi lại API)
    async confirmDataEntryExport() {
      const p = this.dePreview
      if (!p || !p.total) return
      const ex = p.ex, rpf = p.rpf
      const chunks: any[][] = []
      for (let i = 0; i < ex.rows.length; i += rpf) chunks.push(ex.rows.slice(i, i + rpf))
      hideModal(this.$refs.dataEntryExportModalRef as HTMLElement | null)
      for (let idx = 0; idx < chunks.length; idx++) {
        exportStyledXlsx({
          title: `FILE NHẬP LIỆU ỨNG VIÊN${chunks.length > 1 ? ` — PHẦN ${idx + 1}/${chunks.length}` : ''}`,
          summary: `${chunks[idx].length} ứng viên${chunks.length > 1 ? ` (phần ${idx + 1}/${chunks.length}, tổng ${ex.total})` : ''}. KHÔNG sửa/xoá cột Mã định danh và dòng tiêu đề.`,
          sheetName: 'Nhập liệu',
          fileBaseName: `file-nhap-lieu-ung-vien${chunks.length > 1 ? `-phan-${idx + 1}` : ''}`,
          columns: ex.columns,
          rows: chunks[idx],
        })
        if (chunks.length > 1 && idx < chunks.length - 1) await new Promise(r => setTimeout(r, 500))
      }
      //Xuất xong -> bỏ tick chọn (nhất là khi xuất theo record đã chọn)
      this.checkedCustomers = []
      this.checkDefault = false
      if (chunks.length > 1) Swal.fire({ text: `Đã tạo ${chunks.length} file (mỗi file tối đa ${rpf} dòng, tổng ${ex.total} ứng viên). Nếu trình duyệt hỏi, hãy cho phép tải nhiều file.`, icon: 'success', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
    },
    //Đọc file (aoa) tại trình duyệt — gửi thô, backend tự dò dòng header + validate
    async onDataEntryFilePicked(e: any) {
      const file = e.target?.files?.[0]
      e.target.value = ''
      if (!file) return
      this.dataEntryImport = null
      this.dataEntryImportLoading = true
      try {
        const buf = await file.arrayBuffer()
        const wb = XLSX.read(buf, { type: 'array' })
        const aoa = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, raw: false, defval: '' }) as any[][]
        if (!aoa || aoa.length < 2) throw new Error('File rỗng hoặc không đọc được.')
        //đếm dòng dữ liệu = sau dòng header (dòng chứa "MÃ ĐỊNH DANH")
        const hIdx = aoa.findIndex(r => Array.isArray(r) && r.some(c => String(c || '').trim().indexOf('MÃ ĐỊNH DANH') === 0))
        const rowCount = hIdx >= 0 ? aoa.slice(hIdx + 1).filter(r => Array.isArray(r) && r.some(c => String(c || '').trim() !== '')).length : 0
        if (hIdx < 0) throw new Error('File thiếu cột "MÃ ĐỊNH DANH" — vui lòng dùng đúng file đã xuất.')
        if (!rowCount) throw new Error('File không có dòng dữ liệu nào.')
        this.dataEntryImport = { aoa, fileName: file.name, rowCount }
      } catch (err: any) {
        Swal.fire({ text: err?.message || 'Không đọc được file.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
      }
      this.dataEntryImportLoading = false
    },
    async submitDataEntryImport() {
      if (!this.dataEntryImport || this.dataEntrySubmitting) return
      this.dataEntrySubmitting = true
      await axios.post('/admission/student/dataentry/import', { aoa: this.dataEntryImport.aoa })
        .then(({ data }) => {
          hideModal(this.$refs.importDataEntryModalRef as HTMLElement | null)
          this.dataEntryImport = null
          this.getData(this.filter)
          const results = data.results || []
          const line = (icon: string, text: string) => `<div class="mb-1"><i class="bi ${icon} me-2"></i>${text}</div>`
          const warnCount = results.filter((r: any) => r.status !== 'error' && r.warnings && r.warnings.length).length
          Swal.fire({
            title: 'Kết quả nhập dữ liệu',
            html: `<div class="text-start fs-6">` +
              line('bi-people-fill text-primary', `File có <b>${data.total}</b> dòng`) +
              line('bi-check-circle-fill text-success', `<b>${data.updated}</b> ứng viên được cập nhật`) +
              (data.unchanged ? line('bi-dash-circle text-muted', `<b>${data.unchanged}</b> dòng không thay đổi`) : '') +
              (data.errorCount ? line('bi-x-octagon-fill text-danger', `<b>${data.errorCount}</b> dòng lỗi — không lưu`) : '') +
              (warnCount ? line('bi-exclamation-triangle-fill text-warning', `<b>${warnCount}</b> dòng có cảnh báo nghiệp vụ (đã lưu)`) : '') +
              `<div class="mt-3"><span id="btn-dataentry-report" class="btn btn-sm btn-light-primary"><i class="bi bi-download me-1"></i>Tải báo cáo chi tiết</span></div>` +
              `</div>`,
            icon: data.errorCount ? 'warning' : 'success',
            buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
            onOpen: () => { document.getElementById('btn-dataentry-report')?.addEventListener('click', () => this.exportDataEntryReport(results)) },
          })
        })
        .catch(({ response }) => {
          Swal.fire({ text: response?.data?.errorMessage || response?.data?.message || 'Nhập dữ liệu thất bại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        })
      this.dataEntrySubmitting = false
    },
    //Báo cáo chi tiết import (mỗi dòng: trạng thái + field đã đổi + cảnh báo + lỗi) — xuất Excel
    exportDataEntryReport(results: any[]) {
      const statusLabel: any = { updated: 'Đã cập nhật', unchanged: 'Không đổi', error: 'LỖI — không lưu' }
      const columns: XlsxColumn[] = [
        { label: 'Dòng', width: 7, align: 'C' },
        { label: 'Mã định danh', width: 38 },
        { label: 'Họ tên', width: 24, wrap: true },
        { label: 'Trạng thái', width: 16, align: 'C' },
        { label: 'Nhóm đã cập nhật', width: 30, wrap: true },
        { label: 'Cảnh báo', width: 44, wrap: true },
        { label: 'Lỗi', width: 44, wrap: true },
      ]
      exportStyledXlsx({
        title: 'BÁO CÁO NHẬP FILE NHẬP LIỆU ỨNG VIÊN',
        summary: `Tổng ${results.length} dòng`,
        sheetName: 'Báo cáo',
        fileBaseName: 'bao-cao-nhap-lieu-ung-vien',
        columns,
        rows: results.map((r: any) => [
          r.rowNo, r.id, r.name || '', statusLabel[r.status] || r.status,
          (r.changedGroups || []).join(', '), (r.warnings || []).join(' · '), (r.errors || []).join(' · '),
        ]),
      })
    },
    //Tạo file "danh sách dòng lỗi" và giữ URL cho link trong popup kết quả — KHÔNG auto-tải nữa
    async downloadFile(data) {
        await axios.post(`/admission/export/excel/importedfailedstudent`,
              data,
              { responseType: 'blob' }
        ).then((response) => {
              this.urlImport = URL.createObjectURL(new Blob([response.data], {
                  type: 'application/vnd.ms-excel'
              }))
        }).catch(err => {
        })
    },
    initDropzone() {
      let this_ = this
      if (Dropzone.instances.length > 0) {
          Dropzone.instances.forEach((e: any) => {
              e.off();
              e.destroy();
          });
      }
      let myDropzone = new Dropzone("#id_dropzone", { 
          url:`${process.env.VUE_APP_API_URL}/admission/import/csv`,
          headers:{"Authorization":'Bearer ' + this.getCookie("accessToken")}, 
          //Backend /admission/import/csv CHỈ parse CSV theo file mẫu (42 cột) — không nhận .xlsx
          //(file "hồ sơ chưa đồng bộ" .xlsx tải từ tab Đồng bộ nguyện vọng chỉ để THAM KHẢO, không import trực tiếp)
          dictDefaultMessage: "Nhấn vào đây để chọn file .csv theo file mẫu",
          dictInvalidFileType: "Chỉ nhận file .csv theo file mẫu — file Excel hãy Save As sang CSV UTF-8",
          dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 25MB",
          dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 1 files",
          maxFilesize: 25,
          maxFiles: 1,
          addRemoveLinks: true,
          acceptedFiles: ".csv",
          init: function () {
              var startUpload = document.getElementById("uploadFiles");
              myDropzone = this;
              myDropzone.removeAllFiles()
              document.querySelectorAll(".dz-preview").forEach(e => e.remove());
              startUpload?.addEventListener("click", function (file) {
                  // console.log('file',file)
                  myDropzone.processQueue();
                  
              });
              this.on("removedfile",async function (file) {
                  // if(file && file.fileName) {
                  //     await axios.delete(`/admission/file/${file.fileName}`)
                  // }
              });
              this.on("success",async function (file, response) {
                  const data = response.importResult
                  const okStudents = data.importedSuccess?.students?.length || 0
                  const okAdregs = data.importedSuccess?.admissionRegisters?.length || 0
                  const failStudents = data.importedFailed?.students?.length || 0
                  const failAdregs = data.importedFailed?.admissionRegisters?.length || 0
                  const addrWarns = data.addressWarnings?.length || 0
                  //file danh sách dòng lỗi: tải qua LINK trong popup (kèm cột lý do), không auto-download
                  let download = ""
                  if (failStudents != 0 || failAdregs != 0) {
                    await this_.downloadFile({ importedFailed: data.importedFailed })
                    download = `<div class="mt-3"><a download="danhsachloi.xlsx" href="${this_.urlImport}" target="_blank"><b>Tải danh sách dòng lỗi</b></a> — mở file xem cột lý do, sửa rồi import lại các dòng đó.</div>`
                  }
                  const line = (icon, text) => `<div class="mb-1"><i class="bi ${icon} me-2"></i>${text}</div>`
                  const html = `<div class="text-start fs-6">` +
                    line("bi-check-circle-fill text-success", `<b>${okStudents}</b> ứng viên mới được tạo`) +
                    line("bi-check-circle-fill text-success", `<b>${okAdregs}</b> hồ sơ xét tuyển được tạo`) +
                    (failStudents ? line("bi-exclamation-triangle-fill text-warning", `<b>${failStudents}</b> dòng ứng viên lỗi / trùng CCCD`) : "") +
                    (failAdregs ? line("bi-exclamation-triangle-fill text-warning", `<b>${failAdregs}</b> dòng hồ sơ xét tuyển lỗi`) : "") +
                    (addrWarns ? line("bi-geo-alt-fill text-warning", `<b>${addrWarns}</b> dòng không tra được mã tỉnh/xã — địa chỉ để TRỐNG, cập nhật sau trong hồ sơ ứng viên`) : "") +
                    download + `</div>`
                  //đóng modal import TRƯỚC khi hiện kết quả (hết popup chồng modal) + reload danh sách ngay
                  hideModal(this_.$refs.addExporResultModalRef as HTMLElement | null)
                  this_.getData(this_.filter)
                  Swal.fire({
                        title: "Kết quả import",
                        html,
                        icon: (failStudents || failAdregs || addrWarns) ? "warning" : "success",
                        buttonsStyling: false,
                        confirmButtonText: "Đóng",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                    });
              });
              this.on("error",function (file, response) {
                  //BE trả errorMessage (không phải message); response cũng có thể là chuỗi thô
                  const errText = typeof response == 'string'
                    ? response
                    : (response?.errorMessage || response?.message || 'Import thất bại. Kiểm tra file .csv đúng theo file mẫu (đủ cột).')
                  Swal.fire({
                      text: errText,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "Trở lại",
                      customClass: {
                          confirmButton: "btn btn-primary",
                      },
                  }).then(() => {
                      Swal.close()
                  });  

              })
          }
      });
  },
    callModalDelete() {
      this.callFunctionModal?.showModal()
    },
    checkAll(value) {
      this.checkDefault = value
      this.checkedCustomers = []
      if(!value) {
        return
      }
      const el = document.querySelectorAll('.form-auto-check') 
      el.forEach( e =>{
        let ele =  e as HTMLInputElement
        this.checkedCustomers.push(ele.value as never)
      });
    },
    //Xuất Excel FE styled (mẫu promotion.vue): BE trả columns+rows ĐÃ format theo studentClassicSpec
    async exportFile(data: any) {
      await axios.post(`/admission/export/json/listofstudent`, data)
      .then(({ data: ex }) => {
          exportStyledXlsx({
            title: 'DANH SÁCH ỨNG VIÊN',
            summary: `Tổng: ${ex.total} ứng viên`,
            sheetName: 'Ứng viên',
            fileBaseName: 'danh-sach-ung-vien',
            columns: ex.columns,
            rows: ex.rows,
          })
          Swal.close()
          hideModal(this.exportModalRef)
      }).catch(err=> {
          Swal.close()
      })
    },
    async exportFileExcel(data: any) {
      if (!this.exportFormRef) {
        return;
      }
      this.exportFormRef.validate(async (valid) => {
        if (valid) {
          Swal.fire({
          html: "<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
          buttonsStyling: false,
          timerProgressBar: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
      })
      
      let tempData = { file_name: 'danh-sach-ung-vien-dang-ky-xet-tuyen.xlsx'} as any
      try {
        if(this.formData.typeOption == 0) {
          // return
        }
        else {
          if(this.formData.typeOption == 1) {
            tempData.assigneeId = this.formData.assignee
          }
          else if(this.formData.typeOption == 2) {
            tempData.groupAssigneeId = this.formData.groupAssignee
          }

        }
        this.exportFile(tempData)
      } catch (error) {
          Swal.close()
      }
      }
    })
  },
    async filterData(filter) {
      let infUser = this.userLocal
      let usergroups = filter?.groupAssignee
      let userassignee = filter?.assignee
      if(infUser.role != 1 && infUser.role != 3) {
        if(infUser.usergroups && infUser.usergroups[0]) {
          usergroups = infUser.usergroups[0].groupId
        }
        userassignee = infUser.id
      }
      let data = {
        "filter": {
            "month": filter?.month,
            "highschoolGraduation": filter?.status == "all"?undefined:filter?.status == "null"?"blank":filter?.status,
            "class12ProvinceId":filter?.class12ProvinceId,
            "class12SchoolId": filter?.class12SchoolId,
            "hasAmount": filter?.hasAmount,
            "prProvinceId": filter?.prProvinceId,
            "groupAssignee": usergroups,
            "assignee": userassignee,
            "badmajor": filter?.badmajor,
            "dupidcard": filter?.dupidcard,
            "bgdsync": filter?.bgdsync || undefined,
            // isarticulationprogram: this.isPageLienThong,
        }
      }
      this.filter = data.filter

      await this.getData(data.filter)
    },
    popupLoading() {
      Swal.fire({
        html: "<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      })
    },
    // Mở bộ lọc "Lỗi ngành" từ banner cảnh báo
    showBadMajorFilter() {
      const fb: any = this.$refs.filterList
      if (fb && fb.applyBadMajorFilter) fb.applyBadMajorFilter()
    },
    // Xuất Excel danh sách ứng viên của banner cảnh báo (lỗi ngành / trùng CCCD) — để share cho team
    // xử lý (banner chỉ admin/phụ trách thấy). Lọc đúng phạm vi phụ trách như số đếm trên banner.
    async exportBannerList(kind: 'badmajor' | 'dupidcard') {
      this.popupLoading()
      try {
        const infUser = this.userLocal
        let usergroups: any, userassignee: any
        if (infUser && infUser.role != 1 && infUser.role != 3) {
          if (infUser.usergroups && infUser.usergroups[0]) usergroups = infUser.usergroups[0].groupId
          userassignee = infUser.id
        }
        const filter: any = { groupAssignee: usergroups, assignee: userassignee }
        if (kind === 'badmajor') filter.badmajor = 1
        else filter.dupidcard = 1
        const { data } = await axios.post(`/admission/student/filter?page=1&pagesize=100000`, { filter })
        const items = (data && data.items) || []
        //Xuất FE styled (mẫu promotion.vue) thay json2excel backend không style được
        const columns: XlsxColumn[] = [
          { label: 'Họ tên', width: 26, wrap: true },
          { label: 'SĐT', width: 13 },
          { label: 'CCCD', width: 15 },
          { label: 'Tỉnh/TP L12', width: 18, wrap: true },
          { label: 'Trường L12', width: 30, wrap: true },
          { label: 'Số lượng hồ sơ', width: 12, align: 'C' },
          { label: 'Ngày tạo', width: 12, align: 'C' },
          { label: 'Cập nhật', width: 12, align: 'C' },
          { label: 'Phụ trách', width: 22, wrap: true },
          { label: 'Tình trạng TN THPT', width: 18 },
          { label: 'Cần xử lý', width: 44, wrap: true },
        ]
        exportStyledXlsx({
          title: kind === 'badmajor' ? 'ỨNG VIÊN CÓ HỒ SƠ LỖI NGÀNH' : 'ỨNG VIÊN TRÙNG CCCD',
          summary: `Tổng: ${items.length} ứng viên cần xử lý`,
          sheetName: 'Cần xử lý',
          fileBaseName: kind === 'badmajor' ? 'ung-vien-loi-nganh' : 'ung-vien-trung-cccd',
          columns,
          rows: items.map((it: any) => [
            it.fullName,
            it.phone,
            it.idCard,
            it.class12Province?.name || '',
            it.class12School?.name || '',
            it.amount ?? '',
            it.createdAt ? moment(it.createdAt).format('DD/MM/YYYY') : '',
            it.updatedAt ? moment(it.updatedAt).format('DD/MM/YYYY') : '',
            this.getInforName(this.arrUsers, it.assignee, 'fullName') || '',
            (this.statusTag as any)[it.highschoolGraduation]?.label || 'Chưa xác định',
            kind === 'badmajor' ? 'Có hồ sơ lỗi ngành (chưa chọn ngành / ngành đã xoá)' : 'Trùng CCCD với ứng viên khác',
          ]),
        })
        Swal.close()
      } catch (e) {
        console.log('err', e)
        Swal.close()
      }
    },
    // Đếm số hồ sơ lỗi ngành (theo phạm vi phụ trách của user) để hiện banner
    async loadBadMajorCount() {
      try {
        const infUser = this.userLocal
        let usergroups: any, userassignee: any
        if (infUser && infUser.role != 1 && infUser.role != 3) {
          if (infUser.usergroups && infUser.usergroups[0]) usergroups = infUser.usergroups[0].groupId
          userassignee = infUser.id
        }
        const { data } = await axios.post(`/admission/student/filter?page=1&pagesize=1`, {
          filter: { badmajor: 1, groupAssignee: usergroups, assignee: userassignee },
        })
        this.badMajorCount = (data && data.total) || 0
      } catch (e) {
        this.badMajorCount = 0
      }
    },
    // Mở bộ lọc "Trùng CCCD" từ banner cảnh báo
    showDupIdCardFilter() {
      const fb: any = this.$refs.filterList
      if (fb && fb.applyDupIdCardFilter) fb.applyDupIdCardFilter()
    },
    // Đếm số ứng viên trùng CCCD (theo phạm vi phụ trách của user) để hiện banner
    async loadDupIdCardCount() {
      try {
        const infUser = this.userLocal
        let usergroups: any, userassignee: any
        if (infUser && infUser.role != 1 && infUser.role != 3) {
          if (infUser.usergroups && infUser.usergroups[0]) usergroups = infUser.usergroups[0].groupId
          userassignee = infUser.id
        }
        const { data } = await axios.post(`/admission/student/filter?page=1&pagesize=1`, {
          filter: { dupidcard: 1, groupAssignee: usergroups, assignee: userassignee },
        })
        this.dupIdCardCount = (data && data.total) || 0
      } catch (e) {
        this.dupIdCardCount = 0
      }
    },
    async getData(filter) {
      this.loading = true
      this.tableData = []
      this.initCustomers = []
      // console.log('filter',filter)
      await axios.post(`/admission/student/filter?page=${this.pagination.currentPage}&pagesize=${this.pagination.limit}`,{
        filter: filter,
        keyword: this.search?this.search.trim():undefined,
      })
      .then(( {data} ) => {
        this.pagination.total = data.total
        // Dựng mảng cục bộ rồi gán 1 LẦN — tránh push 100 lần vào mảng reactive (mỗi push khiến KTDatatable
        // re-init lại toàn bộ widget). Gán một lần → chỉ re-render/re-init đúng 1 lần.
        const rows = (data.items || []).map((item: any) => ({
          ...item,
          fullName: titleCaseName(item.fullName), // chuẩn hoá hiển thị Title Case (dữ liệu cũ lẫn CHỮ HOA)
          location: item.class12Province?.name,
          school: item.class12School?.name,
          phoneNumber: item.phone,
          id: item.id,
          idCard: item.idCard,
          date: moment(item.createdAt).format('DD/MM/YYYY'),
          checkbox: true,
          numberProfile: item.amount,
          status: item.status,
          highschoolGraduation: item.highschoolGraduation,
          lastModifiedBy: item.lastModifiedBy ? item.lastModifiedBy.split('_')[0] : '',
          groupAssignee: item.groupAssignee,
          assignee: item.assignee,
          //nền đỏ = TRÙNG CCCD (nặng nhất); nền vàng = cảnh báo tốt nghiệp (helper dùng chung với trang chi tiết/drawer)
          _rowClass: item.dupIdCard ? 'umt-row-danger' : (gradWarningsOf(item).length ? 'umt-row-warning' : ''),
        }))
        // Lưu ý: sort này chỉ sắp xếp TRANG hiện tại (server đã phân trang) — giữ nguyên hành vi cũ
        rows.sort((a: any, b: any) => Number(new Date(b.updatedAt)) - Number(new Date(a.updatedAt)))
        this.tableData = rows
        this.initCustomers = rows.slice()
        this.loading = false
      })
      .catch(({ response }) => {
      });
    },
    currentChange(currentPage,limit = 0) {
      // console.log('currentPage',currentPage)
      this.pagination.currentPage = currentPage
      // console.log('limit',limit)
      if(limit == 0) {
        limit = this.pagination.limit
      }
      else {
        this.pagination.limit = limit
      }
      this.getData(this.filter)
    }
  },
  async created() {
    this.getArrUsers()
    this.getArrGroups()
    // Khôi phục từ khoá tìm kiếm đã lưu (giữ giá trị lọc khi rời trang rồi quay lại).
    // Đặt TRƯỚC khi FilterBar mounted emit filter -> getData sẽ kèm đúng từ khoá này.
    try { const _s = localStorage.getItem('tsSearch:' + (window.location.pathname || '')); if (_s) this.search = _s } catch (e) { /* ignore */ }
    this.loadBadMajorCount()
    this.loadDupIdCardCount()
    //await this.getData(this.pagination.currentPage,this.pagination.limit)
  },
  setup() {
    const exportModalRef = ref<null | HTMLElement>(null);
    const assigneeModalRef = ref<null | HTMLElement>(null);
    
    Dropzone.autoDiscover = false;
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 25,
    });
    const checkedCustomers = ref([]);
    const checkDefault = ref(false)
    const instance = getCurrentInstance() // để gọi method getData()/loadXxxCount() từ trong setup sau khi xóa
    const filterList = ref<any>();
    const callFunctionModal = ref<any>();
    const formData = ref<any>({
      typeOption: 1,
      assignee: '',
      groupAssignee: ''
    })
    // Ngữ cảnh modal Gán: bao nhiêu ứng viên ĐANG có người phụ trách (cảnh báo ghi đè) — set ở handleClickModalAssign
    const assignCurrent = ref<any>({ assigned: 0, namesText: '' })
    const userLocal = computed(() => {
      let temp = window.localStorage.getItem("user")
      return temp ? JSON.parse(temp) : null
    });
    const isPageLienThong = computed(() => {
      const optionPage = {
        lienthong: 'danhsachdangkylienthong',
        ungvien: 'danhsachungvien',
      }
      const page = location.pathname.replace('/','')
      return page == optionPage.lienthong
    });
    const isSuperAdmin = computed(() => {
      let infUser = userLocal.value
      if(infUser.role == 1 || infUser.role == 3) {
        return true
      }
      return false
    });
    const rules = ref({
      
    })
    //2 form phải TÁCH ref — trước đây cùng ref="formRef" nên validate/reset chạy nhầm form
    //(lỗi đỏ hiện sẵn khi mở modal Gán dù chưa đụng gì)
    const assignFormRef = ref<null | HTMLFormElement>(null);
    const exportFormRef = ref<null | HTMLFormElement>(null);
    const kt_modal_assignRef = ref<null | HTMLElement>(null);
    const submit = () => {
      if (!assignFormRef.value) {
        return;
      }
      assignFormRef.value.validate(async (valid) => {
        if (valid) {
       
          let tempData = {
              "ids": checkedCustomers.value,
              "groupAssignee": formData.value.groupAssignee?formData.value.groupAssignee:null,
              "assignee": formData.value.assignee?formData.value.assignee:null
          }
            await axios.put(`/admission/student/update/assignee`, tempData)
            .then(() => {
              // Gán xong: đóng modal + BỎ CHỌN + reload list (giữ filter/từ khóa); popup tự tắt, không bắt bấm.
              // Message tự viết (BE trả "Assigneed successfully" sai chính tả + tiếng Anh).
              const total = tempData.ids.length
              hideModal(assigneeModalRef.value)
              checkedCustomers.value.length = 0
              checkDefault.value = false
              const proxy: any = instance && instance.proxy
              if (proxy) proxy.getData(proxy.filter)
              Swal.fire({
                  html: `Đã gán phụ trách cho <b>${total}</b> ứng viên.`,
                  icon: "success",
                  timer: 2000,
                  showConfirmButton: false,
              });
            })
            .catch(({ response }) => {
              Swal.fire({
                  text: "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  // location.reload()
              });  
            });
        } 
      });
    };
    let tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
        class:"d-flex",
        method: "checkall",
      },
      {
        name: "HỌ TÊN",
        key: "fullName",
        sortable: true,
        class: "min-w-175px text-nowrap", //tên không rớt 2 dòng
      },
      {
        name: "CCCD",
        key: "idCard",
        // sortable: true,
      },
      {
        name: "Điện thoại",
        key: "phoneNumber",
        sortable: true,
        class: "min-w-100px text-nowrap",
      },
      {
        name: "Tỉnh/TP L12",
        key: "location",
        sortable: true,
        class: "min-w-100px text-nowrap",
      },
      {
        name: "Trường L12",
        key: "school",
        sortable: true,
      },
      {
        name: "SLHS",
        key: "numberProfile",
        sortable: false,
        class:"text-center",
      },
      {
        name: "Ngày tạo / Sửa",
        key: "date",
        sortable: false,
        class: "text-nowrap",
      },
      
      
    ]);
    if(isPageLienThong.value) {
      tableHeader.value = tableHeader.value.filter(i => i.key != 'numberProfile')
    }
    if(isSuperAdmin.value) {
      let temp = {
        name: "Phụ trách",
        key: "assignee",
        sortable: false,
        class: " ",
      } as any
      tableHeader.value.push(temp)
    }
    //bỏ cột icon goDetail (2026-07): click lên row đã vào chi tiết — đồng bộ Danh sách hồ sơ
    tableHeader.value.push(
      //đồng bộ điểm với Bộ GD&ĐT (bgdsync ghi khi Import điểm từ Bộ) — cột riêng, tách khỏi Tình trạng tốt nghiệp
      {
        name: "BGD",
        key: "bgdsync",
        sortable: false,
        class: "text-center"
      } as any,
      {
        name: "TÌNH TRẠNG",
        key: "highschoolGraduation",
        sortable: false,
        class: "text-end"
      }
    )
    const tableData = ref<Array<ICustomer>>([]);
    const initCustomers = ref<Array<ICustomer>>([]);
    const statusTag =  {
      "graduated": {
        label:"Đã tốt nghiệp",
        state: "success",
      },
      "temp_graduated": {
        label:"Chứng nhận TNTT",
        state: "warning",
      },
      "not_graduated": {
        label:"Chưa tốt nghiệp",
        state: "danger",
      },
      "null": {
        label:"Chưa xác định",
        state: "info",
      },
      // "rejected": {
      //   label:"Không hợp lệ",
      //   state: "danger",
      // },
    }
    onMounted(async () => {
       //getData()
      //initCustomers.value.splice(0, tableData.value.length, ...tableData.value);
      //console.log(tableData.value)
    });
    // force=true: bỏ qua cảnh báo "xóa nhầm bản đang giữ hồ sơ" của backend (chỉ khi người dùng xác nhận)
    const deleteFewCustomers = (reason = undefined, force = false) => {
      const ids = JSON.parse(JSON.stringify(checkedCustomers.value));
      let data = {
        ids,
        isDelete: true,
        reason: reason,
        force,
      };
      axios.put(`/admission/student/update/ids/`, data)
      .then((response) => {
        // Xóa thành công -> dọn lựa chọn + RELOAD list từ server (đúng phân trang/tổng) + cập nhật cảnh báo.
        // Lưu ý: trước đây dọn checkedCustomers.value=[] chạy ĐỒNG BỘ trước khi .then resolve nên forEach
        // (splice cục bộ) không xóa được item nào -> list không đổi. Nay reload hẳn cho chắc & đúng dữ liệu.
        checkedCustomers.value.length = 0;
        checkDefault.value = false;
        Swal.close();
        const proxy: any = instance && instance.proxy;
        if (proxy) {
          proxy.getData(proxy.filter);
          if (proxy.loadBadMajorCount) proxy.loadBadMajorCount();
          if (proxy.loadDupIdCardCount) proxy.loadDupIdCardCount();
        }
      })
      .catch(({ response }) => {
        // Backend cảnh báo đang xóa nhầm bản MANG hồ sơ (bản trùng còn lại rỗng) -> hỏi lại,
        // cho phép vẫn xóa nếu người dùng khẳng định. Xem guard DELETE_WOULD_LOSE_PROFILE ở BE.
        if (response?.data?.code === 'DELETE_WOULD_LOSE_PROFILE') {
          Swal.fire({
            title: "Khoan đã — có thể bạn đang xóa nhầm",
            html: `${response.data.message}`,
            icon: "warning",
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: "Tôi chắc chắn, vẫn xóa",
            cancelButtonText: "Để tôi kiểm tra lại",
            customClass: {
              confirmButton: "btn btn-danger order-2",
              cancelButton: "btn btn-light order-1",
            },
          }).then((r: any) => {
            if (r.isConfirmed) { deleteFewCustomers(reason, true); }
          });
          return;
        }
        Swal.fire({
            text: response.data?.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Trở lại",
            customClass: {
                confirmButton: "btn btn-primary",
            },
        }).then(() => {
            Swal.close()
        });
      });
    };
    const deleteCustomer = async (id) => {
      for (let i = 0; i < tableData.value.length; i++) {
        if (tableData.value[i].id === id) {
          tableData.value.splice(i, 1);
        }
      }
      for (let i = 0; i < initCustomers.value.length; i++) {
        if (initCustomers.value[i].id === id) {
          initCustomers.value.splice(i, 1);
          return
        }
      }
    };
   const search = ref<string>("");
    const searchItems = () => {
      
      return
      tableData.value.splice(0, tableData.value.length, ...initCustomers.value);
      if (search.value !== "") {
        let results: Array<ICustomer> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }
    };
    const searchingFunc = (obj, value): boolean => {
      obj = JSON.parse(JSON.stringify(obj))
      obj.status = statusTag[obj.status]?.label
      for (let key in obj) {
        if (obj[key] && (typeof obj[key] === "string")) {
          if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      tableData,
      initCustomers,
      tableHeader,
      deleteCustomer,
      search,
      checkedCustomers,
      deleteFewCustomers,
      pagination,
      statusTag,
      searchItems,
      filterList,
      Permission,
      checkDefault,
      callFunctionModal,
      formData,
      assignCurrent,
      assignFormRef,
      exportFormRef,
      rules,
      kt_modal_assignRef,
      submit,
      exportModalRef,
      assigneeModalRef,
      userLocal,
      isPageLienThong,
    };
  },
});
